import { AdminLayout } from "@/components/layout/AdminLayout";
import { Button } from "@/components/ui/button";

const mockData = [
  {
    id: 1,
    srNo: "001154",
    masterFolder: "z_reference",
    subfolder: "910000_removed_on",
    titleEnglish: "Song Of The Soul",
    titleLanguage: "Song Of The Soul",
    authors: "SushilKumar",
  },
  {
    id: 2,
    srNo: "001793",
    masterFolder: "z_reference",
    subfolder: "910000_removed_on",
    titleEnglish: "Tithi Prashnona...",
    titleLanguage: "related to dates",
    authors: "Yogic Victory",
  },
  {
    id: 3,
    srNo: "001154",
    masterFolder: "z_reference",
    subfolder: "910000_removed_on",
    titleEnglish: "Bhagwan Mahavir",
    titleLanguage: "Basic thoughts of",
    authors: "JayKumar Ja",
  },
  {
    id: 4,
    srNo: "001154",
    masterFolder: "z_reference",
    subfolder: "910000_removed_on",
    titleEnglish: "Narya Sahayamela",
    titleLanguage: "Drama Mother",
    authors: "Yogitasuri",
  },
];

const ReferenceBook = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="mb-2 text-3xl font-bold text-foreground">
              Reference Book List
            </h2>
            <div className="text-sm">
              <span className="text-muted-foreground">Files Found</span>
              <div className="text-lg font-semibold">732</div>
            </div>
          </div>
          <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
            Export Data
          </Button>
        </div>

        {/* Table */}
        <div className="overflow-hidden rounded-lg border border-border bg-card">
          <table className="w-full">
            <thead className="bg-muted/50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  SR.NO.
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Master Folder
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Subfolder
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Title English
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Title Language
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Authors
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {mockData.map(item => (
                <tr key={item.id} className="hover:bg-muted/30">
                  <td className="px-6 py-3 text-sm">{item.srNo}</td>
                  <td className="px-6 py-3 text-sm">{item.masterFolder}</td>
                  <td className="px-6 py-3 text-sm">{item.subfolder}</td>
                  <td className="px-6 py-3 text-sm">{item.titleEnglish}</td>
                  <td className="px-6 py-3 text-sm">{item.titleLanguage}</td>
                  <td className="px-6 py-3 text-sm">{item.authors}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-center gap-2">
          <Button variant="outline" size="sm">
            « First
          </Button>
          <Button variant="outline" size="sm">
            ‹ Back
          </Button>
          <Button variant="outline" size="sm">
            1
          </Button>
          <Button size="sm" className="bg-primary text-primary-foreground">
            2
          </Button>
          <Button variant="outline" size="sm">
            3
          </Button>
          <Button variant="outline" size="sm">
            4
          </Button>
          <Button variant="outline" size="sm">
            ...
          </Button>
          <Button variant="outline" size="sm">
            120
          </Button>
          <Button variant="outline" size="sm">
            Next ›
          </Button>
          <Button variant="outline" size="sm">
            Last »
          </Button>
        </div>
      </div>
    </AdminLayout>
  );
};

export default ReferenceBook;
